// dayjs thay moment (nhẹ hơn ~65KB gzip) — antd v5 đã dùng dayjs sẵn trong bundle.
// Bật đủ plugin cho các API mà code cũ gọi theo kiểu moment:
//   parse theo format ("YYYYMMDD"), fromNow, isSameOrAfter/Before, startOf("quarter")
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import quarterOfYear from "dayjs/plugin/quarterOfYear";

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(quarterOfYear);

export default dayjs;
